{
  "version": 1,
  "asset_id": "1940f032-1e66-4098-aa51-11469430efca",
  "project_id": "81e5f51e-81a3-47ad-9e0d-7249ca4c0a70",
  "url": "/__l5e/assets-v1/1940f032-1e66-4098-aa51-11469430efca/author-tessa-blokpoel.jpg",
  "r2_key": "a/v1/81e5f51e-81a3-47ad-9e0d-7249ca4c0a70/1940f032-1e66-4098-aa51-11469430efca/author-tessa-blokpoel.jpg",
  "original_filename": "author-tessa-blokpoel.jpg",
  "size": 24833,
  "content_type": "image/jpeg",
  "created_at": "2026-08-30T14:15:06Z"
}
